/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  GetHospitalQueryResponse,
  GetHospitalPathParams,
  GetHospital404,
} from '../../types/GetHospital'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getHospital } from '../../clients/getHospital'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getHospitalQueryKey = ({
  hospital_id,
}: {
  hospital_id: GetHospitalPathParams['hospital_id']
}) =>
  [
    {
      url: '/api/v1/hospital/:hospital_id/',
      params: { hospital_id: hospital_id },
    },
  ] as const

export type GetHospitalQueryKey = ReturnType<typeof getHospitalQueryKey>

export function getHospitalQueryOptions(
  { hospital_id }: { hospital_id: GetHospitalPathParams['hospital_id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = getHospitalQueryKey({ hospital_id })
  return queryOptions<
    GetHospitalQueryResponse,
    ResponseErrorConfig<GetHospital404>,
    GetHospitalQueryResponse,
    typeof queryKey
  >({
    enabled: !!hospital_id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getHospital(
        { hospital_id: hospital_id },
        { ...config, signal: config.signal ?? signal }
      )
    },
  })
}

/**
 * @summary Get hospital detail
 * {@link /api/v1/hospital/:hospital_id/}
 */
export function useGetHospital<
  TData = GetHospitalQueryResponse,
  TQueryData = GetHospitalQueryResponse,
  TQueryKey extends QueryKey = GetHospitalQueryKey,
>(
  { hospital_id }: { hospital_id: GetHospitalPathParams['hospital_id'] },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetHospitalQueryResponse,
        ResponseErrorConfig<GetHospital404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? getHospitalQueryKey({ hospital_id })

  const query = useQuery(
    {
      ...getHospitalQueryOptions({ hospital_id }, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<GetHospital404>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
